import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, ModalService, NotificationService } from 'yt-ng-framework';
import { Provajder } from './provajder';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-provajder-update',
  templateUrl: './provajder-update.component.html'
})
export class ProvajderUpdateComponent extends BaseUpdateComponent<Provajder> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);
  }

  ngOnInit() {
    super.ngOnInit();
    //this.addValidatorToFc("Naziv",Validators.required);
  }

}
